
import React from 'react'



export const ProgresBar = ({notes}) => {
    return (
    <form action="">
 
      </form>
    );
};